import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f9cc6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_fulfillment_pre_stock_out_list",
  ref: "addPreStockOutList",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-header border-0 pt-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1))
const _hoisted_11 = { class: "card-toolbar" }
const _hoisted_12 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_13 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_14 = { class: "svg-icon svg-icon-2" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "modal-body p-0" }
const _hoisted_17 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_stock_out_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_stock_out_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_stock_out_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_18 = { class: "row mb-7" }
const _hoisted_19 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_20 = { class: "form-group d-flex flex-wrap" }
const _hoisted_21 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_22 = { style: {"min-height":"100px"} }
const _hoisted_23 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_24 = { class: "modal-footer flex-right" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "indicator-label" }
const _hoisted_28 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_29 = { class: "indicator-progress" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("shipments.selectProducts")), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                  ]),
                  _createVNode(_component_FilterDropdown, {
                    onSubmitFilter: _ctx.handleFilter,
                    onResetFilter: _ctx.handleReset,
                    customer: _ctx.options.customer,
                    shipmentType: _ctx.props.submitData.shipment_type
                  }, null, 8, ["onSubmitFilter", "onResetFilter", "customer", "shipmentType"])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.props.fulfillment_order_number == '']
            ]),
            _createVNode(_component_el_form, {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              rules: _ctx.rules,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.props.submitData.shipment_type == '2')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("shipments.customDeclarationBy")), 1),
                                _createVNode(_component_el_form_item, { prop: "custom_declaration_by" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio_group, {
                                      modelValue: _ctx.formData.custom_declaration_by,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.custom_declaration_by) = $event)),
                                      size: "mini",
                                      onChange: _ctx.typeChange,
                                      disabled: _ctx.props.custom_declaration_by != ''
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.custom_declaration_by, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_radio, {
                                            key: item.value,
                                            label: item.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.label), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode(_component_el_table, {
                      class: "mb-7 w-100",
                      ref: "multipleTableRef",
                      data: _ctx.options.list,
                      onSelect: _ctx.handleSelectChange,
                      onSelectionChange: _ctx.handleSelectionChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "selection",
                          width: "50"
                        }),
                        _createVNode(_component_el_table_column, {
                          property: "sku_identifier",
                          label: _ctx.t('order.skuIdentifier'),
                          width: "140"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.image'),
                          width: "150"
                        }, {
                          default: _withCtx(({ row }) => [
                            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [
                              (_ctx.getProductIdData(row.sku_identifier)?.gallery)
                                ? (_openBlock(), _createBlock(_component_el_carousel, {
                                    key: 0,
                                    "indicator-position": "none",
                                    height: "100px",
                                    autoplay: false,
                                    arrow: "never"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductIdData(
                              row.sku_identifier
                            )?.gallery, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                          key: index,
                                          class: "d-flex justify-content-center align-items-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_image, {
                                              style: {"width":"100px","height":"100px","cursor":"pointer"},
                                              src: 
                                item.origin_url +
                                '?x-oss-process=image/resize,l_200'
                              ,
                                              fit: "contain",
                                              onClick: ($event: any) => (
                                _ctx.previewImages(
                                  _ctx.getProductIdData(row.sku_identifier)?.gallery,
                                  index
                                )
                              )
                                            }, null, 8, ["src", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ])), [
                              [_directive_loading, _ctx.options.loadingProducts]
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.articleInformation'),
                          width: "180"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.name_en), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.name), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.__show.brand_id), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.brand_article_no), 1)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.articleAttributes'),
                          width: "120"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.t("order.size")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.__show.size), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.t("order.color")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.original_color), 1)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (
                      _ctx.props.fulfillment_order_type == _ctx.FulfillmentSource.Merchant
                    )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              label: _ctx.t('fulfillmentOrder.remainingQty'),
                              align: "right"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.max_quantity), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                      _ctx.props.fulfillment_order_type == _ctx.FulfillmentSource.Merchant
                    )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 1,
                              label: _ctx.t('fulfillmentOrder.qty'),
                              width: "120"
                            }, {
                              default: _withCtx(({ $index }) => [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_el_input_number, {
                                    class: "text-start w-100",
                                    modelValue: 
                            _ctx.options.cloneTableData[$index].request_quantity
                          ,
                                    "onUpdate:modelValue": ($event: any) => ((
                            _ctx.options.cloneTableData[$index].request_quantity
                          ) = $event),
                                    onBlur: _ctx.setTableSelect,
                                    precision: 0,
                                    step: 1,
                                    min: 0,
                                    max: _ctx.options.cloneTableData[$index].max_quantity,
                                    controls: false
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "max"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 2,
                              label: _ctx.t('shipments.quantity'),
                              prop: "actual_quantity",
                              align: "right"
                            }, null, 8, ["label"])),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.relatedFulfilmentOrder'),
                          prop: "fulfillment_order_number"
                        }, null, 8, ["label"]),
                        (
                      _ctx.props.fulfillment_order_type != _ctx.FulfillmentSource.Merchant
                    )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 3,
                              label: _ctx.t('order.relatedSalesOrder'),
                              prop: "sale_order_number"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                      _ctx.props.fulfillment_order_type != _ctx.FulfillmentSource.Merchant
                    )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 4,
                              label: _ctx.t('order.customer'),
                              prop: "customer_name"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                      _ctx.props.fulfillment_order_type != _ctx.FulfillmentSource.Merchant
                    )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 5,
                              label: _ctx.t('salesOrder.priority')
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.is_vip == 0
                          ? _ctx.t("salesOrder.priorityNormal")
                          : _ctx.t("salesOrder.priorityVip")), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                      _ctx.props.fulfillment_order_type != _ctx.FulfillmentSource.Merchant
                    )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 6,
                              label: _ctx.t('shipments.warehouse'),
                              prop: "warehouse_name",
                              width: "220"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                      _ctx.props.fulfillment_order_type != _ctx.FulfillmentSource.Merchant
                    )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 7,
                              label: _ctx.t('order.orderCreatedDate'),
                              width: "220"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.created_at)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data", "onSelect", "onSelectionChange"])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light me-3",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
                  }, [
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToPrevious")), 1)
                  ]),
                  _createElementVNode("button", {
                    ref: "submitButton",
                    type: "submit",
                    class: "btn btn-lg btn-primary",
                    disabled: _ctx.isDisabledSubmit
                  }, [
                    _createElementVNode("span", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                    ]),
                    _createElementVNode("span", _hoisted_29, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_30
                    ])
                  ], 8, _hoisted_26)
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}